import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onDismiss", "colors", "className", "closeLabel", "children", "clsPrefix", "dark", "closable", "showIcon", "message", "description"];

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Icon from '../../wui-icon/src';
import { WebUI } from "../../wui-core/src/index.js";
var defaultIcon = /*#__PURE__*/React.createElement(Icon, {
  type: "uf-close"
});
var propTypes = {
  onDismiss: PropTypes.func,
  closable: PropTypes.bool,
  showIcon: PropTypes.bool,
  message: PropTypes.string,
  description: PropTypes.string,
  closeLabel: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
  dark: PropTypes.bool
};
var defaultProps = {
  closeLabel: defaultIcon,
  closable: true,
  showIcon: true,
  message: "",
  description: "",
  dark: false
};
var Alert = (_dec = WebUI({
  name: "alert",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Alert, _React$Component);

  var _super = _createSuper(Alert);

  function Alert(props) {
    var _this;

    _classCallCheck(this, Alert);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "renderDismissButton", function (onDismiss) {
      return /*#__PURE__*/React.createElement("div", {
        className: "close",
        onClick: onDismiss
      }, _this.props.closeLabel);
    });

    _defineProperty(_assertThisInitialized(_this), "renderCurrentChildren", function () {
      var _this$props = _this.props,
          message = _this$props.message,
          description = _this$props.description;

      var renderMessage = function renderMessage() {
        return message ? /*#__PURE__*/React.createElement("div", {
          className: "message"
        }, message) : null;
      };

      var renderDescription = function renderDescription() {
        return description ? /*#__PURE__*/React.createElement("div", {
          className: "description"
        }, description) : null;
      };

      var renderChildren = function renderChildren() {
        return !message && !description && _this.props.children;
      };

      return /*#__PURE__*/React.createElement("div", {
        className: "content"
      }, renderMessage(), renderDescription(), renderChildren());
    });

    return _this;
  }
  /**
   * 渲染右上角关闭alert按钮
   */


  _createClass(Alert, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onDismiss = _this$props2.onDismiss,
          colors = _this$props2.colors,
          className = _this$props2.className,
          closeLabel = _this$props2.closeLabel,
          children = _this$props2.children,
          clsPrefix = _this$props2.clsPrefix,
          dark = _this$props2.dark,
          closable = _this$props2.closable,
          showIcon = _this$props2.showIcon,
          message = _this$props2.message,
          description = _this$props2.description,
          others = _objectWithoutProperties(_this$props2, _excluded);

      var iconType = {
        info: 'uf-i-c',
        success: 'uf-correct',
        danger: 'uf-exc-c',
        warning: 'uf-exc-t'
      };
      var clsObj = {};
      clsObj["".concat(clsPrefix)] = true;

      if (colors) {
        clsObj["".concat(clsPrefix, "-").concat(colors)] = true;
      } else {
        clsObj["".concat(clsPrefix, "-warning")] = true;
      }

      if (dark) {
        clsObj["dark"] = true;
      }

      return /*#__PURE__*/React.createElement("div", _extends({}, others, {
        role: "alert",
        className: classNames(className, clsObj)
      }), showIcon ? /*#__PURE__*/React.createElement(Icon, {
        className: "show-icon",
        type: iconType[colors]
      }) : null, this.renderCurrentChildren(), closable && this.renderDismissButton(onDismiss));
    }
  }]);

  return Alert;
}(React.Component)) || _class);
Alert.propTypes = propTypes;
export default Alert;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-alert/src/Alert.js